// AI Organization Settings Types
export const BYO_AI_PROVIDERS = ['anthropic', 'google', 'openai'];
export const isByoAiProvider = (provider) => BYO_AI_PROVIDERS.includes(provider);
//# sourceMappingURL=adminTypes.js.map